import { render, staticRenderFns } from "./ClassItems.vue?vue&type=template&id=e1b0ca72&"
import script from "./ClassItems.vue?vue&type=script&lang=js&"
export * from "./ClassItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b0ca72')) {
      api.createRecord('e1b0ca72', component.options)
    } else {
      api.reload('e1b0ca72', component.options)
    }
    module.hot.accept("./ClassItems.vue?vue&type=template&id=e1b0ca72&", function () {
      api.rerender('e1b0ca72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/ClassItems.vue"
export default component.exports